import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';

export const trackOpenFloorPlans = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'floorplan link'
    });
};

export const trackOpenVirtualTours = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'video gallery link'
    });
};

export const trackOpenTenancyInfo = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'open tab',
        eventLabel: 'tenancy information'
    });
};

export const trackOpenGuidePrice = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'open tooltip',
        eventLabel: 'auction guide price'
    });
};
